import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { defaultRowsPerPage } from '../../../../utils/common';
import { dayBookHeadCells } from '../data';
import { LedgerTransactionModalv2 } from '../../../LedgerTransaction';
import Listing from '../../../../components/listing';
import { listDayBookTransactionDetails, listDayBookTransactionsCount } from '../../../../graphql';
import { useSelector } from 'react-redux';
const DayBook = ({ dayBookData, setTableData, dataCount, setdataCount, showSearch, dayBookList, handleChangePage }) => {
  const [accountID, setAccountID] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  const [debo, setDebo] = useState({});
  const dashboardData = useSelector((state) => state?.DashboardDataReducer);
  const { startTimeStamp, endTimeStamp } = dashboardData?.report;
  function filterValidValues(data) {
    const isValidValue = (value) => {
      if (value === null || value === undefined || value === '') return false;
      if (typeof value === 'object' && !Array.isArray(value)) {
        const keys = Object.keys(value);
        return keys.length > 0 && keys.some((key) => value[key] !== '');
      }
      return true;
    };

    return Object.fromEntries(Object.entries(data).filter(([key, value]) => isValidValue(value)));
  }

  const processObject = (obj) => {
    const result = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];

        // Check if the value is an object (not null or array)
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          const keys = Object.keys(value);

          // Proceed only if the object has more than one key
          if (keys.length > 1) {
            const secondKey = keys[1];

            // Case 1: If the second field's key is "value", update the parent field
            if (secondKey === 'value') {
              obj[key] = value[secondKey];
            }
            // Case 2: If the second field's key is "to"
            else if (secondKey === 'to' || secondKey === 'max') {
              const fromValue = value['from'];
              const toValue = value['to'];
              const minValue = value['min'];
              const maxValue = value['max'];
              // Check if both "from" and "to" fields are present (including empty strings)

              if (fromValue && toValue) {
                // Update only if both are present, even if empty
                obj[key] = { [`${key}from`]: fromValue, [`${key}to`]: toValue };
              } else if (minValue || maxValue) {
                // Update only if both are present, even if empty
                obj[key] = { [`${key}from`]: minValue, [`${key}to`]: maxValue };
              } else {
                obj[key] = { from: '', to: '' };
              }
            }
          }
        }
      }
    }
    return obj;
  };
  const processObject2 = (obj) => {
    const result = {};

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          const keys = Object.keys(value);
          const isFromTo = keys.every((k) => k.endsWith('from') || k.endsWith('to') || k.endsWith('min') || k.endsWith('max'));

          if (isFromTo) {
            for (const innerKey in value) {
              if (value.hasOwnProperty(innerKey)) {
                result[innerKey] = value[innerKey];
              }
            }
          } else {
            result[key] = value;
          }
        } else {
          result[key] = value;
        }
      }
    }
    return result;
  };

  useEffect(() => {
    dayBookList(true, 0, rowsPerPage);
  }, [startTimeStamp, endTimeStamp]);
  function trimFlatObject(obj) {
    console.log(obj, 'obj');

    return Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, typeof value === 'string' ? value.trim() : value]));
  }
  const trimmed = trimFlatObject(debo);
  const changeObj = processObject(trimmed);
  const newObj = processObject2(changeObj);

  const lastObj = filterValidValues(newObj);

  const groupByVoucherAndTransaction = (data) => {
    const map = new Map(); // key = vouchernumber + transactiontype

    for (const item of data) {
      const key = `${item.vouchernumber}__${item.transactiontype || ''}`;
      if (!map.has(key)) map.set(key, []);
      map.get(key).push(item);
    }
    for (const arr of map.values()) {
      arr.sort((a, b) => {
        if (a.transactiontypecd !== b.transactiontypecd) {
          return a.transactiontypecd === 'Debit' ? -1 : 1;
        }
        return (a.entryordernumber ?? 0) - (b.entryordernumber ?? 0);
      });
    }
    return Array.from(map, ([groupKey, items]) => [groupKey, items]);
  };

  const groupedData2 = groupByVoucherAndTransaction(dayBookData);
  return (
    <>
      <Box
        sx={{
          width: '100%',
          // borderRadius: 2,
          '.MuiTableCell-root': {
            padding: '5px',
          },
          overflowX: 'scroll',
        }}
      >
        <Listing
          bodyData={groupedData2}
          setBodyData={setTableData}
          headData={dayBookHeadCells}
          showSearch={showSearch}
          count={dataCount}
          setAccountID={setAccountID}
          dayBook={true}
          setPage={setPage}
          setDataCount={setdataCount}
          countVariable="transactioncount"
          queryCount={listDayBookTransactionsCount}
          queryCountName="listDayBookTransactionsCount"
          rowsPerPage={rowsPerPage}
          page={page}
          query={listDayBookTransactionDetails}
          startTimeStamp={startTimeStamp}
          endTimeStamp={endTimeStamp}
          queryName="listDayBookTransactionDetails"
          queryParams="enteredtimestamp"
          ordertype="desc"
          debo={debo}
          setDebo={setDebo}
          searchArr={lastObj}
          setRowsPerPage={setRowsPerPage}
        />
      </Box>
      {accountID && <LedgerTransactionModalv2 open={accountID} accountId={accountID} onClose={() => setAccountID('')} />}
    </>
  );
};
export default DayBook;
